import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-duotone-svg-icons';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="hs-footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4">
            <a className="footer-brand" href="/">
              <span className="brand-icon">
                <FontAwesomeIcon icon={faUsers} />
              </span>
              Headstation
            </a>
            <p className="footer-tagline">
              Agricultural Operations Technology.<br />
              Bespoke cloud-based IT infrastructure to manage fleets and agricultural operations.
            </p>
          </div>

          <div className="col-6 col-lg-2 offset-lg-2">
            <p className="footer-heading">Company</p>
            <ul className="footer-links">
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('services')}>Services</button></li>
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('solutions')}>Solutions</button></li>
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('technology')}>Technology</button></li>
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <p className="footer-heading">Solutions</p>
            <ul className="footer-links">
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('solutions')}>BinTracker</button></li>
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('solutions')}>Timekeeper</button></li>
              <li><button className="btn btn-link p-0 footer-links" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.88rem' }} onClick={() => scrollTo('solutions')}>Resources</button></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <p className="footer-heading">Contact</p>
            <ul className="footer-links">
              <li><a target="_blank" href="https://www.linkedin.com/company/headstation-australia">LinkedIn</a></li>
            </ul>
          </div>
        </div>

        <hr className="footer-divider" />
        <p className="footer-copyright mb-0">© {year} Headstation. All rights reserved.</p>
      </div>
    </footer>
  );
}
